import { TmdxAvatar } from '@ds';

type ResourceNameProps = {
  fullName: string;
  photoPath?: string;
};

export const ResourceName = ({ fullName, photoPath }: ResourceNameProps) => {
  return (
    <div className="flex items-center gap-2">
      <div className="flex flex-col shrink-0 items-center overflow-hidden">
        <TmdxAvatar className="shrink-0" size="sm" radius="sm" name={fullName} src={photoPath} />
      </div>
      <div className="text-s-sb">{fullName}</div>
    </div>
  );
};
